import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, Clock } from "lucide-react";
import { useSubscription } from "@/contexts/SubscriptionContext";

const TrialStatusBanner = () => {
  const { subscriptionStatus, subscriptionEnd } = useSubscription();
  
  if (subscriptionStatus === 'active') return null;

  const isExpired = subscriptionStatus === 'expired';
  
  const getDaysRemaining = () => {
    if (!subscriptionEnd) return 0;
    const end = new Date(subscriptionEnd);
    const now = new Date();
    const diff = end.getTime() - now.getTime();
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  };

  const daysRemaining = getDaysRemaining();

  if (isExpired) {
    return (
      <Alert className="bg-red-900/20 border-red-500 mb-6">
        <AlertCircle className="h-5 w-5 text-red-500" />
        <AlertDescription className="text-white ml-2">
          <span className="font-semibold">Trial Expired</span> - Upgrade now to restore access to all premium features
        </AlertDescription>
      </Alert>
    );
  }

  if (daysRemaining > 7) {
    return (
      <Alert className="bg-green-900/20 border-green-500 mb-6">
        <Clock className="h-5 w-5 text-green-500" />
        <AlertDescription className="text-white ml-2">
          <span className="font-semibold">{daysRemaining} days remaining</span> in your free trial
        </AlertDescription>
      </Alert>
    );
  }

  if (daysRemaining > 0) {
    return (
      <Alert className="bg-yellow-900/20 border-yellow-500 mb-6">
        <Clock className="h-5 w-5 text-yellow-500" />
        <AlertDescription className="text-white ml-2">
          <span className="font-semibold">Only {daysRemaining} days left</span> in your trial - Upgrade to continue uninterrupted access
        </AlertDescription>
      </Alert>
    );
  }

  return null;
};

export default TrialStatusBanner;
